export default __webpack_public_path__ + "static/media/arrow-left.8d34b8e0.svg";